/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


$(document).ready(function(){
  $('.switch-btn .switch input').click(function(){
    $(this).parents('.attachment_slider_container').toggleClass('show_img');
  });

  $('.faq-head').click(function(){
    $(this).next().slideToggle('is-open');
    $(this).parents('.card').toggleClass('is-open');
  });
  $('.faq-que').click(function(){
    $(this).next().slideToggle('active-sub');
    $(this).parents('.faq-sub-qty-ans').toggleClass('is-open');
  });
  
  $('.__products_section .switch input').change(function(){
    var id = $(this).parent('.switch').data('id');
    if($(this).is(":checked")){
      $(this).parents().find('.ProductForm__Option #product-select-'+id+' option').eq(1).prop('selected', true).change();
    }else{
      $(this).parents().find('.ProductForm__Option #product-select-'+id+' option').eq(0).prop('selected', true).change();
    }
  });
  $('.switch__Option').change(function(){
    var productid = $(this).data('product-id'),
        variantid = $(this).val(),
        productdata = JSON.parse($('#product-json-'+productid+'').html()),
        product = productdata.product,
        variant = product.variants,
        i;
    console.log(product);	
    for(i=0; i < variant.length;i++){
      var Item = variant[i];
      if(Item.id == variantid){
        var price = Item.price;
        $('.metaprice-'+productid+' .ProductMeta__Price').html(Shopify.formatMoney(price, window.theme.moneyFormat));
      }
    }
  });
});


$(document).ready(function() {
  $('li.active').removeClass('active');
  $('a[href="' + location.pathname + '"]').closest('li').addClass('active'); 
});